import { BoardsOnboardingStep } from '../../../constants/Feature';

export const BOARDS_ONBOARDING_STEPS = [BoardsOnboardingStep.FloatingNotification];
